import React from 'react';
import * as R from 'ramda';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { MDropdown } from 'common';
import { ANY_VALUE } from 'feature/loading-management/utils/const';

const FiltersPopover = ({
  cancelButtonStyles,
  carrierOrLocationOptions,
  filters: { nameShort, state },
  handleClose,
  lgUp,
  resetCardFilters,
  stateOptions,
  setFilters,
  viewBy,
}) => {
  const showClear = R.o(R.not, R.all(R.equals(ANY_VALUE)))([nameShort, state]);

  return (
    <>
      {!lgUp && (
        <>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5">Filters</Typography>
            <IconButton onClick={handleClose} size="large" sx={cancelButtonStyles}>
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <Divider />
        </>
      )}
      {carrierOrLocationOptions.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="carrier-or-location-select"
          items={carrierOrLocationOptions}
          label={viewBy === 'carrier' ? 'Location' : 'Carrier'}
          name="nameShort"
          onChange={setFilters}
          value={nameShort}
        />
      )}
      {stateOptions.length > 2 && (
        <MDropdown
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          id="state-select"
          items={stateOptions}
          label="State"
          name="state"
          onChange={setFilters}
          value={state}
        />
      )}
      {showClear && (
        <Button onClick={() => resetCardFilters()} sx={{ mx: 'auto', my: 1 }} variant="text">
          Clear
        </Button>
      )}
    </>
  );
};

FiltersPopover.propTypes = {
  cancelButtonStyles: shape({}).isRequired,
  carrierOrLocationOptions: arrayOf(shape({})).isRequired,
  filters: shape({
    nameShort: string.isRequired,
    state: string.isRequired,
  }).isRequired,
  handleClose: func.isRequired,
  lgUp: bool.isRequired,
  resetCardFilters: func.isRequired,
  setFilters: func.isRequired,
  stateOptions: arrayOf(shape({})).isRequired,
  viewBy: string.isRequired,
};

export default FiltersPopover;
